<template>
  <div class="change-password-page">
    <ChangePassword :email="getEmail" :token="getToken" />
  </div>
</template>

<script>
import { ChangePassword } from '@/features/login';

export default {
  components: { ChangePassword },
  computed: {
    getEmail() {
      return this.$route.params.email;
    },
    getToken() {
      return this.$route.params.token;
    },
  }
};
</script>
